import { gsap } from 'gsap';
import gsapCore from 'gsap/gsap-core';
import Scrolltrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(Scrolltrigger);
gsap.config({ nullTargetWarn: false, });

let menuFlg = true;
let contactFlg = true;
$(document).on('click', '.menu-btn', function () {
  let $this = $(this);
  let $tar = $('.menuArea');
  $this.stop().toggleClass('open');
  if (menuFlg) {
    gsap.to($tar, {
      autoAlpha: 1,
      duration: 0.5
    });

    $('body').addClass('stopscroll');
    $('html').addClass('stopscroll');
    menuFlg = false;
    if (contactFlg == false) {
      gsap.to('.navArea', {
        autoAlpha: 0,
        duration: 0.5
      });
      contactFlg = true;

    }

  } else {

    gsap.to($tar, {
      autoAlpha: 0,
      duration: 0.5
    });

    $('body').removeClass('stopscroll');
    $('html').removeClass('stopscroll');
    menuFlg = true;
  }
  return false;
});

$(document).on('click', '.menuArea .close_btn > a, .menuArea .jsScroll', function () {
  let $tar = $('.menuArea');
  gsap.to($tar, {
    autoAlpha: 0,
    duration: 0.5
  });
  $('body').removeClass('stopscroll');
  $('html').removeClass('stopscroll');
  menuFlg = true;
  $('.menu-btn').removeClass('open');
  // return false;
});

$(document).on('click', '.menuArea > ul > li > a', function () {
  let $this = $(this);
  let $tar = $('.menuArea');

  if (contactFlg) {
    gsap.to($tar, {
      autoAlpha: 1,
      duration: 0.5
    });
    $('body').addClass('stopscroll');
    $('html').addClass('stopscroll');
    contactFlg = false;

    if (menuFlg == false) {
      gsap.to('.menuArea', {
        autoAlpha: 0,
        duration: 0.5
      });
      //$('.menu-btn').find('.word').text('MENU');
      $this.stop().toggleClass('open');
      menuFlg = true;
    }

  } else {

    gsap.to($tar, {
      autoAlpha: 0,
      duration: 0.5
    });
    $('body').removeClass('stopscroll');
    $('html').removeClass('stopscroll');
    contactFlg = true;

  }
  return false;
});


$(window).on('scroll', function() {
  // スクロール量を取得
  var scrollY = $(window).scrollTop();
  // 200px スクロールしたら
  if (scrollY >= 200) {
    // 要素にクラスを付与
    $(".hd_cnt").addClass("scr_hd");
  } else {
    // 要素からクラスを削除
    $(".hd_cnt").removeClass("scr_hd");
  }
});


/*$(function(){
  $('.gnav-search').on('click', function() {
    $(this).addClass("is-select");
  });

  var otherSearch = $('.contentWrap').not(".gnav-search");
  otherSearch.on('click', function() {
    $('.gnav-search').removeClass("is-select");
  });


});

$(document).on('click', function(e) {
  if(!$(e.target).closest('.gnav-search').length) {
    $(this).removeClass("is-select");
  }
});

//ボタンをクリックすると開く
$('.gnav-search').on('click', function(e) {
  e.stopPropagation();
  $(this).addClass("is-select");
});*/
